import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { Chart } from "chart.js";
import { lineChartOptions } from "~/misc/charts";
import moment from "moment";

export default class extends Controller {
	connect() {
		const charts = $('#toJs').data('charts');

		const year = moment().month() > 6 ? moment().year() : moment().year() - 1;
		const maxDate = moment([year, 9, 1]);

		charts.forEach(function (chart: any) {
			//p(chart);
			const ctx = $('#' + chart.id)[0] as HTMLCanvasElement;
			const options = Object.assign({}, lineChartOptions);
			options.scales!.x = {
				type: 'time',
				time: {
					unit: 'day',
					tooltipFormat: 'MM.DD HH:mm',
					displayFormats: {
						minute: 'HH:mm',
						hour: 'MM.DD HH:mm',
						day: 'MM.DD'
					}
				},
				//suggestedMax: maxDate
			};
			options.scales!.y!.title!.text = chart.title;
			options.scales!.y!.min = 0;
			new Chart(ctx, {
				type: 'line',
				data: {
					datasets: chart.datasets
				},
				options: options
			});
		});
	}
}

